import { createFileRoute, redirect } from '@tanstack/react-router';
import DutyManagerPage from '../pages/DutyManagerPage';
import { getProfileSync } from '../lib/getProfileSync';

export const Route = createFileRoute('/duty-manager')({
  beforeLoad: () => {
    const profile = getProfileSync();
    if (!profile || profile.status !== 'active') {
      throw redirect({ to: '/' });
    }
    if (!['DutyManager', 'Manager', 'Admin'].includes(profile.role)) {
      throw redirect({ to: '/' });
    }
  },
  component: DutyManagerPage,
});
